
export const BASE_URL = process.env.REACT_APP_API_HOST
    ? (process.env.REACT_APP_API_HOST + process.env.REACT_APP_CONTEXT_PATH) + process.env.REACT_APP_API_BASE
    : window.location.origin + process.env.REACT_APP_CONTEXT_PATH + process.env.REACT_APP_API_BASE

export class DataError extends Error implements APIError {
    title: string
    status: number
    error: string
    errorDetails: Record<string, any>
    constructor(status: number, title: string, error: string, details?: Record<string, any>) {
        super(error)
        this.status = status
        this.title = title
        this.errorDetails = details;
    }
}

export interface APIError {
    title: string
    status: number
    error: string
    errorDetails: Record<string, any>
}

export interface APISuccess<T> {
    status: number
    data: T
}


export enum EndPoint {
    APP_ENVIRONMENT = '/environment',
    DOGS = '/dogs',
    FILTERS = '/filters',
    INSTITUTIONS = '/institutions',
    CITIES = '/locations/cities',
    ZIPCODES = '/locations/zipcodes',
    PARTNERSHIPS = '/institutions/partnerships',
    CITY_PROXIMITY = '/locations/city',
    ZIPCODE_PROXIMITY = '/locations/zip',
    PERSON_PROXIMITY = '/locations/geo',
}

export type APIResponse<T> = APISuccess<T> | APIError

export class DataProvider {
    static API_URL = new URL(BASE_URL)

    static async get<Res = any>(endpoint: string, query?: Record<string, any>): Promise<APISuccess<Res>> {
        const targetUrl = new URL(this.API_URL + endpoint);
        if (query) Object.keys(query).forEach(key => targetUrl.searchParams.set(key, query[key]));
        const response = await fetch(targetUrl.toString(), {
            //mode: 'cors',
            headers: {
                'content-type': 'application/json',
            },
            //credentials: 'include'
        },
        )
        const responseBody = await response.json();
        if (response.status >= 400) {
            throw new DataError(response.status, responseBody.title, responseBody.error, responseBody.errorDetails)
        }
        return {
            status: 200,
            data: responseBody
        }
    }

    static async requestWithBody<Sent = any, Res = any>(method: string, endpoint: string, headers: Record<string, string>, body?: Sent): Promise<APISuccess<Res>> {
        const targetUrl = new URL(this.API_URL + endpoint);
        const response = await fetch(targetUrl.toString(), {
            method,
            // headers: {
            //     'content-type': 'application/json',
            // },
            //credentials: 'include',
            body: JSON.stringify(body)
        });
        const responseBody = await response.json();
        if (response.status >= 400) {
            throw new DataError(response.status, responseBody.error, responseBody.errorDetails)
        }
        return {
            status: 200,
            data: responseBody
        }
    }

    static async post<Sent = any, Res = any>(endpoint: string, body?: Sent): Promise<APISuccess<Res>> {
        return this.requestWithBody('POST', endpoint, { 'Content-Type': 'application/json' }, body)
    }

}